import { m } from 'framer-motion';
import styles from './styles.module.scss';
import { itemVariants } from '../variants';
import { CoinflipBoardResultCoinProps } from './props';
import { memo } from 'react';
import { CoinSide } from '@/models/bet/coinflip/side';
import { Image } from '@starsoft/common/components';

function CoinflipBoardResultCoin({
  side,
  isLoading,
}: CoinflipBoardResultCoinProps) {
  const tailImage = `${process.env.NEXT_PUBLIC_S3_BUCKET_BASE_URL}/artworks/coinflip/tail.svg`;
  const headImage = `${process.env.NEXT_PUBLIC_S3_BUCKET_BASE_URL}/artworks/coinflip/head.svg`;

  if (isLoading) {
    return (
      <div className={styles.container}>
        <div className={styles.skeleton} />
      </div>
    );
  }

  return (
    <m.li className={styles.container} variants={itemVariants}>
      <Image
        className={styles['container__image']}
        format="square"
        width={300}
        height={300}
        src={side == CoinSide.Heads ? headImage : tailImage}
        alt={`game-history-${side}`}
        secondarySkeleton
      />
    </m.li>
  );
}

export default memo(CoinflipBoardResultCoin);
